export default function decodeToken(token: string) {
    const base64Url = token.split('.')[1];
    const base64 = base64Url.replace(/-/g, '+').replace(/_/g, '/');
    const rawData = atob(base64);
    const parsedData = JSON.parse(rawData);
    return parsedData;
}